import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import icons, {faSpinner} from '@fortawesome/fontawesome-free-solid';
import './doubleClickBtn.scss';

export class DoubleClickBtn extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onClick(event);
    }

    render() {
        const clicked = this.props.clicked || false;
        const className = this.props.className || "";
        const disabled = this.props.disabled || false;
        const requestInProcess = this.props.process;
        const icon = this.props.icon || null;
        const textOne = this.props.textOne || "";
        const textTwo = this.props.textTwo || "";

        return (
            <div className={`doubleClickBtn ${className}`} onClick={this.handleChange} disabled={requestInProcess}>
                {requestInProcess ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={icons[icon]} />}
                {!requestInProcess && !clicked && ` ${textOne}`}
                {!requestInProcess && clicked && ` ${textTwo}`}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/DoubleClickBtn.jsx